import React, {useState, useEffect } from 'react';
import I18n from '../components/I18n';
import BgVid from "../assets/videos/origami_group.mp4";
import FooterNav from "../components/FooterNav";
import { colors, patterns, messages } from '../origamiConfig';
import { useLocation } from 'react-router-dom';
import {useLocale} from '../Locale';
import { trackPage } from '../adobeAnalytics';

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import Slider from 'react-slick';

const OrigamiGallery = () => {
	const locale = useLocale();
	const location = useLocation();
	const [viewMessage, setViewMessage] = useState(false);
	const [ugcArrays, setUgcArray] = useState([])
	
	//random array for gallery
	
	useEffect(() => {
		const tempArr = []
		const arrLength = 10
		for(var i = 0; i < arrLength; i++){
			//pick random color
			const selectedColor = colors[Math.floor(Math.random() * (colors.length))]
			//pick random pattern
			const selectedPattern = patterns[Math.floor(Math.random() * (patterns.length))]
			//pick random message
			const selectedMessage = messages[Math.floor(Math.random() * (messages.length))]
			//assign to an object
			const ugcObj = {
				color: selectedColor,
				pattern: selectedPattern,
				message: selectedMessage
			}
			//add to array
			tempArr.push(ugcObj)
		}	
		setUgcArray(tempArr)
	}, []);
	

	useEffect(() => {
		trackPage(`${locale}|origami-gallery`, 'gallery');
	}, [locale]);

	const settings = {
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
	  /*centerMode:true,
	  centerPadding:"0px",*/
	  arrows: true,
	};

	const handleMessages = (e) => {
		setViewMessage(!viewMessage);
	}

	
	
    return(
        <div className={"container origami origami-gallery-container fullscreen lang-" + locale}>
			<div className="bg-video">
				<video src={BgVid} playsInline muted autoPlay loop type="video/mp4" />
			</div>
			<div className={"content lang-" + locale}>
				<div className="page-logo lg nissan white">NISSAN</div>
				<div className="origami-gallery">
					<div className="origami-gallery-carousel">
                       	<div className="origami-gallery-carousel-item">
							{ugcArrays.length > 0 ?
							<Slider {...settings}>
								{ugcArrays.map((item, i) => {
									const { text, disclaimer } = item.message;
									const foldedClass = "paper-"+item.color.name + " paper-" + item.pattern.name
									return(
										<div key={i} className="origami-gallery-carousel-item-single">
											<div className={`${viewMessage ? 'foldedImage origami-folded' : 'foldedImage onlyImg origami-folded'} ${foldedClass}`}></div>
											<div className={`${viewMessage ? 'origami-gallery-carousel-item-single-messages' : 'origami-gallery-carousel-item-single-messages-hide'}`}>
												<p dangerouslySetInnerHTML={{__html:I18n.getTranslation(location, text)}}></p>
												<p className="sm" dangerouslySetInnerHTML={{__html:I18n.getTranslation(location, disclaimer)}}></p>
											</div>
										</div>
									)
								})}
							</Slider>
							:""}
                        </div>
                    </div>
				</div>
				<div className="origami-gallery-cta">
					<button className="btn white" onClick={(e) => handleMessages(e.target)}>{viewMessage ? I18n.getTranslation(location, "origami.hideMessage") : I18n.getTranslation(location, "origami.viewMessage")}</button>
				</div>
			</div>
			<FooterNav 
			currentPage={'origami-gallery'} 
			next={{ text: 'sakura.ctaText', url: 'discover' }}
			// prev={{ text: 'general.back', url: 'origami' }} 
			/>
		</div>
    )
}

export default OrigamiGallery;